import React from 'react';
import PropTypes from 'prop-types';
import { Helpers } from 'shared-components/helpers/helpers';
import Overlay from 'react-bootstrap/lib/Overlay';
import _ from 'lodash';

export class DropDownBtn extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      show: false
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.hideDropDown = this.hideDropDown.bind(this);
  }

  toggleShow () {
    this.setState({ show: !this.state.show });
  }

  hideDropDown () {
    const { onHideFn } = this.props;
    this.setState({ show: false }, () => {
      if (_.isFunction(onHideFn)) onHideFn();
    });
  }

  render () {
    const {
      containerClassName,
      buttonId,
      buttonClassName,
      buttonDataValue,
      buttonShownValue,
      buttonChildren,
      children,
      mobileViewOff,
      style
    } = this.props;
    const { show } = this.state;
    const isMobile = Helpers.isMobile();
    const listComponent = React.cloneElement(children, { listToggle: this.toggleShow });
    return (
      <div
        className={`dropdown-container ${containerClassName || ''}`}
      >
        <button
          type="button"
          id={buttonId || null}
          className={`btn dropdown-btn btn-block ${buttonClassName || ''}`}
          onClick={this.toggleShow}
          style={style}
          ref={button => {
            this.target = button;
            return this.target;
          }}
        >
          {
            buttonChildren ?
              React.cloneElement(buttonChildren, { show }) :
              <div>
                <span className="dropdown-value ellipsis" data-value={buttonDataValue}>
                  {buttonShownValue}
                </span>
                <span className={show ? 'arrow up' : 'arrow'} />
              </div>
          }
        </button>
        {
          isMobile && !mobileViewOff ?
            listComponent :
            <Overlay
              container={this}
              show={show}
              placement="bottom"
              target={this.target}
              rootClose
              onHide={this.hideDropDown}
            >
              { listComponent }
            </Overlay>
        }
      </div>
    );
  }
}

DropDownBtn.propTypes = {
  buttonDataValue: PropTypes.string,
  buttonShownValue: PropTypes.string,
  containerClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  buttonChildren: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  mobileViewOff: PropTypes.bool,
  style: PropTypes.object,
  onHideFn: PropTypes.func
};
